import { render } from "./Gameboard_SidePanel_Delivery.vue?vue&type=template&id=91385b26"
import script from "./Gameboard_SidePanel_Delivery.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanel_Delivery.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanel_Delivery.vue?vue&type=style&index=0&id=91385b26&lang=scss"
script.render = render

export default script